import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ListItemText } from '@mui/material';
import useFetch from '../../../../../hooks/useFetch';

interface FileSourceAutocompleteProps {
  value: GeneralSourceAndTypeBundle | null;

  setValue(x: GeneralSourceAndTypeBundle | null): void;
  nameKeyForm: string;
  placeholder: string;
}

export interface GeneralSourceAndTypeBundle {
  [index: string]: string | number;
  id: string;
  name: string;
  url: string;
  prefix: string;
  active_at: string;
  created_at: string;
  updated_at: string;
}

const FileSourceAutocomplete = ({ value, setValue, nameKeyForm, placeholder }: FileSourceAutocompleteProps) => {
  const [fileSourceInputValue, setFileSourceInputValue] = React.useState<string>('');
  const [options, setOptions] = useState<GeneralSourceAndTypeBundle[]>([]);

  const { data, loading } = useFetch<GeneralSourceAndTypeBundle[]>(`${process.env.REACT_APP_URL_HOST}/admin/v1/file_sources`);

  React.useEffect(() => {
    setOptions([...new Set((data || []).map((source: GeneralSourceAndTypeBundle) => source as GeneralSourceAndTypeBundle))]);
  }, [data]);

  return (
    <Autocomplete
      getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name || '')}
      isOptionEqualToValue={(a: GeneralSourceAndTypeBundle, b: GeneralSourceAndTypeBundle) => a.id === b.id}
      filterOptions={createFilterOptions({
        matchFrom: 'start',
        trim: true,
      })}
      autoComplete
      loading={loading}
      includeInputInList
      filterSelectedOptions
      size="small"
      sx={{ width: '100%', bgcolor: '#ffffff', borderRadius: '5px' }}
      value={value}
      onChange={(event: any, newValue: GeneralSourceAndTypeBundle | null) => {
        setValue(newValue);
      }}
      inputValue={fileSourceInputValue}
      onInputChange={(event, newInputValue) => {
        setFileSourceInputValue(newInputValue);
      }}
      options={options}
      renderInput={(params) => <TextField {...params} name={nameKeyForm} required size="small" placeholder={placeholder} fullWidth />}
      renderOption={(props, option) => (
        <li {...props} key={uuidv4()}>
          <ListItemText primary={option.name} />
        </li>
      )}
    />
  );
};

export default FileSourceAutocomplete;
